'use client'

import * as React from 'react'
import type { RichTranslationValues, TranslationValues } from 'next-intl'

interface PrefixedT {
  (key: string, options?: TranslationValues): string
  rich: (key: string, options?: RichTranslationValues) => React.ReactNode
}
export interface AskCfTranslationContextModel {
  getTranslations: (prefix: string) => PrefixedT
}

const AskCfTranslationContext = React.createContext<AskCfTranslationContextModel>(null!)

export const AskCfTranslationProvider = ({
  children,
  i18n,
}: React.PropsWithChildren<{ i18n: PrefixedT }>) => {
  const getTranslations = (prefix: string) => {
    const translator = (key: string, options?: TranslationValues) => {
      return i18n(`${prefix}.${key}`, options)
    }

    // Attach a `.rich` method
    translator.rich = (key: string, options?: RichTranslationValues) => {
      return i18n.rich(`${prefix}.${key}`, options)
    }

    return translator as PrefixedT
  }

  return (
    <AskCfTranslationContext.Provider value={{ getTranslations }}>
      {children}
    </AskCfTranslationContext.Provider>
  )
}

export const useAskCfTranslation = () => {
  const context = React.useContext(AskCfTranslationContext)

  if (context === undefined) {
    throw new Error('useAskCfTranslation must be used within a AskCfTranslationProvider')
  }

  return context
}
